import { Component, computed, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import type { CellClickedEvent, ColDef, GridApi, GridReadyEvent, RowSelectionOptions, Theme } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

const myTheme = themeQuartz;
// .withPart(iconSetQuartzLight);
// .withParams({
//   backgroundColor: '#ffffff',
//   browserColorScheme: 'light',
//   columnBorder: false,
//   fontFamily: 'Arial',
//   foregroundColor: 'rgb(46, 55, 66)',
//   headerBackgroundColor: '#F9FAFB',
//   headerFontSize: 14,
//   headerFontWeight: 600,
//   headerTextColor: '#919191',
//   oddRowBackgroundColor: '#F9FAFB',
//   rowBorder: false,
//   sidePanelBorder: false,
//   spacing: 8,
//   wrapperBorder: false,
//   wrapperBorderRadius: 0,
// });

@Component({
  selector: 'lib-ag-grid-angular-table',
  imports: [AgGridAngular],
  templateUrl: './ag-grid-angular-table.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ag-grid-angular-table.scss',
})
export class AgGridAngularTable<T> {
  #gridApi!: GridApi<T>;
  protected $emitGridReady = output<GridReadyEvent<T>>({ alias: 'gridReady' });
  onGridReady(params: GridReadyEvent<T>) {
    this.#gridApi = params.api;
    this.$emitGridReady.emit(params);
  }

  theme: Theme = myTheme;

  // Row data source
  $dataSource = input.required<T[]>({ alias: 'dataSource' });

  // Column Section
  $columnDefs = input.required<ColDef<T>[]>({ alias: 'columnDefs' });
  $overrideDefaultColDef = input<ColDef | null>(null, { alias: 'defaultColDef' });

  readonly defaultColDef = computed<ColDef>(() => {
    const overRideDefaults = this.$overrideDefaultColDef();
    if (overRideDefaults) {
      return overRideDefaults;
    }
    return this.#defaultColDef;
  });

  #defaultColDef: ColDef = {
    flex: 1,
    sortable: false,
    filter: false,
    resizable: false,
  };

  protected rowClassRules = signal({});

  // Row selction section
  $overrideRowSelection = input<RowSelectionOptions | null>(null, { alias: 'rowSelection' });

  defaultRowSelection: RowSelectionOptions = {
    mode: 'singleRow',
    checkboxes: false,
    enableClickSelection: false,
  };

  /**
   * Any change to the selected rows get the data and output the data to the parent component
   */

  protected $emitSelectionChange = output<T[]>({ alias: 'selectionChangeOutput' });
  protected $emitRowClicked = output<any>({ alias: 'rowClicked' });
  protected $emitCellClicked = output<CellClickedEvent<T>>({ alias: 'cellClicked' });

  onSelectionChanged() {
    const selectedData = this.#gridApi.getSelectedRows();
    // console.log('Selection Changed', selectedData);
    this.$emitSelectionChange.emit(selectedData);
  }
}
